import React from "react";
export function WorkspaceIdentityIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M14.6661 28.0051V13.1029C14.666 12.3954 14.3848 11.7169 13.8844 11.2167L9.33055 6.66284L4.77665 11.2167C4.27631 11.7169 3.99515 12.3954 3.995 13.1029V28.0051" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.33058 16V26.6711" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.23645 11.9985H14.4234" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.33058 3.99512V6.66289" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.6678 28.0052V14.757C18.6679 14.3196 18.8825 13.9101 19.242 13.661C19.6015 13.412 20.0603 13.3549 20.4699 13.5085L27.1393 16.0095C27.6598 16.2046 28.0048 16.7021 28.005 17.258V28.0052" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M29.3389 28.0051H2.66113" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.0025 20.0019H24.6703" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.0025 24.0034H24.6703" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ClockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M21.4217 16.1589H15.2191" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="16.0225" cy="15.3556" r="12.005" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.2191 16.1591V8.68628" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function LanguageIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M9.99998 5.33325V9.33325" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M27.3334 26.6667L22 14.6667L16.6667 26.6667" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.8533 23.9999H26.1467" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.66669 19.9999C10.1267 19.5679 14.9014 14.7933 15.3347 9.33325H4.66802" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.3334 19.9999C11.9214 19.7306 8.93602 16.7453 8.66669 13.3333" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function TickCircleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M8 14V14C4.686 14 2 11.314 2 8V8C2 4.686 4.686 2 8 2V2C11.314 2 14 4.686 14 8V8C14 11.314 11.314 14 8 14Z" stroke="#148DFD" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.6666 6.66675L7.33325 10.0001L5.33325 8.00008" stroke="#148DFD" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function CreditCardIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M19 19H8C6.895 19 6 18.105 6 17V10C6 8.895 6.895 8 8 8H19C20.105 8 21 8.895 21 10V17C21 18.105 20.105 19 19 19Z" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 12H21" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 16H5C3.895 16 3 15.105 3 14V7C3 5.895 3.895 5 5 5H16C17.105 5 18 5.895 18 7V8" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 16H9" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function DownloadIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M15.5576 11.1108L12.0001 14.6683L8.44263 11.1108" stroke="#148DFD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.0002 3.99658V14.668" stroke="#148DFD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.0035 16.4458C20.0035 18.4105 18.4108 20.0033 16.446 20.0033H7.55431C5.58957 20.0033 3.99683 18.4105 3.99683 16.4458" stroke="#148DFD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function CancelBellIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12 4.5C9.51472 4.5 7.5 6.51472 7.5 9V10.5C7.5 11.3284 7.17143 12.0784 6.63604 12.636L6 13.2721V14.25H18V13.2721L17.364 12.636C16.8286 12.0784 16.5 11.3284 16.5 10.5V9C16.5 6.51472 14.4853 4.5 12 4.5Z" stroke="#FF4D4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.125 16.5C10.3481 17.4162 11.116 18.125 12.0625 18.125C13.009 18.125 13.7769 17.4162 14 16.5" stroke="#FF4D4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.75 3.375C10.1642 2.96079 10.8358 2.96079 11.25 3.375" stroke="#FF4D4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
